import http from "./Http";

// -----------------------------------------------------------
// 1) Generar Propuesta de Diversificación Curricular
// GET /sac/prompt0-genDoc
// -----------------------------------------------------------
const generarPropuestaDiversificacion = async () => {
  const res = await http.get("/sac/prompt0-genDoc");
  return res.data;
};

// -----------------------------------------------------------
// 2) Generar títulos de unidades
// GET /sac/generar-unidades?n=10
// -----------------------------------------------------------
const generarTitulosUnidades = async (cantidad = 10) => {
  const res = await http.get(`/sac/generar-unidades?n=${cantidad}`);
  return res.data; 
};

// -----------------------------------------------------------
// 3) Generar situación significativa
// POST /sac/generar_situacion_significativa
// Body: list[str]
// -----------------------------------------------------------
const generarSituacionSignificativa = async (unidadesSeleccionadas = []) => {
  const res = await http.post("/sac/generar_situacion_significativa", unidadesSeleccionadas);
  return res.data;
};

// -----------------------------------------------------------
// 4) Generar temas (y respuestas SeApPromptTemaResponse)
// POST /sac/generar_temas
// Body: SACPromptTemaRequest
// -----------------------------------------------------------
const generarTemas = async (payload) => {
  const res = await http.post("/sac/generar_temas", payload);
  return res.data;
};

// -----------------------------------------------------------
// EXPORTACIÓN
// -----------------------------------------------------------
const SACService = {
  generarPropuestaDiversificacion,
  generarTitulosUnidades,
  generarSituacionSignificativa,
  generarTemas
};

export default SACService;
